import axios from "axios";

// Histórico de execuções (backend /runs): alimenta o dashboard do perfil
const runs = axios.create({
  baseURL: `${process.env.VUE_APP_DATA_BASE_LOCATION}/runs`
});

export default runs;
